const fieldValidation = {
  required: '{{fieldName}} is required',
  pattern: '{{fieldName}} is invalid',
  min: '{{fieldName}} must not be less than {{value}}',
  max: '{{fieldName}} must not be greater than {{value}}',
};

export default fieldValidation;
